import { create } from 'zustand'
import { USER_LOCALE_KEY } from '../lib/locale-detection'

export type Theme = 'dark' | 'light'

interface UIState {
  theme: Theme
  sidebarOpen: boolean
  locale: string
  toggleTheme: () => void
  setTheme: (theme: Theme) => void
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
  setLocale: (locale: string) => void
}

function getInitialTheme(): Theme {
  const stored = localStorage.getItem('axg-theme')
  if (stored === 'light' || stored === 'dark') return stored
  return 'dark'
}

function getInitialLocale(): string {
  return localStorage.getItem('axg-locale') ?? navigator.language ?? 'en-US'
}

const initialTheme = getInitialTheme()
document.documentElement.setAttribute('data-theme', initialTheme)

export const useUIStore = create<UIState>((set) => ({
  theme: initialTheme,
  sidebarOpen: false,
  locale: getInitialLocale(),
  toggleTheme: () =>
    set((state) => {
      const next = state.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem('axg-theme', next)
      document.documentElement.setAttribute('data-theme', next)
      return { theme: next }
    }),
  setTheme: (theme) => {
    localStorage.setItem('axg-theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
    set({ theme })
  },
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setLocale: (locale) => {
    localStorage.setItem('axg-locale', locale)
    // A escolha EXPLÍCITA do usuário vive em USER_LOCALE_KEY — é ela que
    // `resolveInitialLocale` lê no boot (RAIZ 10). Sem esta linha a escolha
    // morria no reload e a tela voltava para pt-BR.
    localStorage.setItem(USER_LOCALE_KEY, locale)
    // RTL preparation: set dir attribute based on locale
    const dir = ['ar', 'he', 'fa', 'ur'].some((l) => locale.startsWith(l)) ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)
    set({ locale })
  },
}))
